import { environment } from '../_graphql/Environment';
import Query from './Query';

export default () => environment;

export {
  Query
};
